import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Modal, Form, Input, InputNumber, Select, Radio, Row, Col, Progress } from 'antd';
import { Loader } from 'components'

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from './reducer';
import saga from './saga';

import { CONTRACTUAL_CATEGORIES } from 'containers/App/contractualCategories';
import { FILTERS_LABELS } from '../Search/constants';
import { MAPPED_FIELDS } from './constants'

import {
  makeSelectIsLoading,
  makeSelectModalIsOpen,
  makeSelectLogic,
  makeSelectCheckResponse,
  makeSelectCheckInputData,
} from './selectors'

import {
  setInputData,
  setContractualCategory,
  sendCheckSustainability,
  resetData,
  resetOfferData,
  closeModal
} from './actions'
import {
  addOption,
  hideTag,
  removeOption,
  showTag,
  enableTags,
} from '../HorizontalFilter/actions';
import { removeParam } from '../Search/actions';

import './styles.scss';
import 'antComponentsStyle';

class PrescoringModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputHasChanged: false,
      inputIsChanging: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleContractualCategoryChange = this.handleContractualCategoryChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleSubmit = (inputName, inputValue) => {
    let { inputData } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};

    if (typeof inputName === 'string' && inputValue && !inputData.answers.hasOwnProperty(inputName)) {
      this.handleInputChange(inputName, inputValue);
    }

    this.props.sendCheckSustainability();

    this.setState({
      inputHasChanged: true,
      inputIsChanging: false,
    });

    this.updateFiltersFromResponse()
  };

  handleCancel = () => {
    this.props.closeModal();
  };

  handleReset = () => {
    this.props.resetData();
    this.props.resetOfferData();
    this.props.enableTags();
    this.resetPrescoringFilters();
  };

  handleContractualCategoryChange = value => {
    this.props.removeOption('piva');
    this.props.removeOption('privati');
    this.props.setContractualCategory(value);
  };

  handleInputChange = (inputName, inputValue) => {
    let { logic, inputData } = this.props;
    inputData = inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData;
    logic = logic && logic.hasOwnProperty('_root') ? [...logic.toJS()] : [...logic] || [];

    if (!Array.isArray(logic)) {
      logic = [];
    }

    let lastLogicIndex = logic.findLastIndex(logicStep =>
      logicStep.q === inputName
    );

    if (lastLogicIndex < 0) {
      lastLogicIndex = 0;
    }

    logic.splice(lastLogicIndex, logic.length);

    const oldFilteredInputDataAnswers = {};

    logic.forEach(logicStep => {
      if (inputData.answers.hasOwnProperty(logicStep.q)) {
        oldFilteredInputDataAnswers[logicStep.q] = inputData.answers[logicStep.q];
      }
    });

    logic[lastLogicIndex] = null;

    const newInputData = {
      ...inputData,
      step: inputName,
      answers: {
        ...oldFilteredInputDataAnswers,
        [inputName]: inputValue
      }
    };

    this.props.setInputData(newInputData);

    this.setState({
      inputHasChanged: false,
      inputIsChanging: inputName,
    });
  };

  get isLastStep() {
    let { logic } = this.props;
    logic = logic && logic.hasOwnProperty('_root') ? logic.toJS() : logic || [];

    return logic.length > 0 && logic.length === this.logicSteps.length;
  }

  get canSubmit() {
    let { inputData, logic } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    logic = logic && logic.hasOwnProperty('_root') ? logic.toJS() : logic || [];
    const answers = Object.keys(inputData.answers || {});

    return (!this.response || !this.response.chance) && logic && logic.length > 0 && answers.length === logic.length;
  }

  get canReset() {
    return this.logicSteps.length > 0
  }

  get response() {
    let { response } = this.props;
    response = response && response.hasOwnProperty('_root') ? response.toJS() : response;

    return response && typeof response.description !== 'undefined' ? response : null;
  }

  get logicSteps() {
    let { logic, inputData } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    logic = logic && logic.hasOwnProperty('_root') ? logic.toJS() : logic || [];

    if (!inputData || !inputData.contractualCategory) {
      return [];
    }

    return logic.filter(logicStep => {
      const lastAnswer = inputData.answers[inputData.step] || null;

      if (lastAnswer) {
        // cerco in tutte le risposte se ce n'è una che ha come action il goto all'attuale step
        const lastLogicStep = logic.find(logicStep2 => logicStep2.q === inputData.step);

        if (lastLogicStep) {
          const lastLogicAnswer = lastLogicStep.a[Number(lastAnswer)];

          if (lastLogicAnswer && lastLogicAnswer.action === 'goto' && lastLogicAnswer.hasOwnProperty('to') && lastLogicAnswer.to === logicStep.q) {
            return true;
          }
        }
      }

      return inputData.answers.hasOwnProperty(logicStep.q) || logicStep.q === inputData.step
    });
  }

  get alertType() {
    switch (this.response.chance) {
      case 0: return 'danger';
      case 1: return 'warning';
      case 2: return 'success';
      default: return 'info';
    }
  }

  getCustomerTypeByContractualCategory = contractualCategory => {
    const contractualCategoryFound = CONTRACTUAL_CATEGORIES.find(contractualCategoryItem => contractualCategoryItem.value === contractualCategory);

    if (contractualCategoryFound) {
      return contractualCategoryFound.type === 'BUSINESS' ? 'piva' : 'privati';
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    let { inputData, response } = this.props;
    let { inputData: inputDataPrev, response: responsePrev } = prevProps;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    response = response && response.hasOwnProperty('_root') ? response.toJS() : response || {};
    inputDataPrev = inputDataPrev && inputDataPrev.hasOwnProperty('_root') ? inputDataPrev.toJS() : inputDataPrev || {};
    responsePrev = responsePrev && responsePrev.hasOwnProperty('_root') ? responsePrev.toJS() : responsePrev || {};

    if (JSON.stringify(inputDataPrev) !== JSON.stringify(inputData) || JSON.stringify(responsePrev) !== JSON.stringify(response)) {
      this.setDefaultAnswerForCurrentStep()
    }
  }

  setDefaultAnswerForCurrentStep() {
    let { logic,  inputData } = this.props;
    logic = logic && logic.hasOwnProperty('_root') ? logic.toJS() : logic || {};
    const { step, answers } = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    const logicStep = logic.find(logicStep => logicStep.q === step);

    if (logicStep && logicStep.hasOwnProperty('default') && !answers.hasOwnProperty(step)) {
      this.handleInputChange(step, logicStep.default);
    }
  }

  updateFiltersFromResponse() {
    let { inputData, response } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    response = response && response.hasOwnProperty('_root') ? response.toJS() : response || {};

    if (inputData.contractualCategory) {
      const customerType = this.getCustomerTypeByContractualCategory(inputData.contractualCategory);
      this.props.addOption(customerType, FILTERS_LABELS[customerType]);
      this.props.hideTag(customerType);
    } else {
      this.resetCustomerTypeFilter();
    }
  }

  resetCustomerTypeFilter() {
    this.props.removeOption('piva');
    this.props.showTag('piva');
    this.props.removeOption('privati');
    this.props.showTag('privati');
  }

  resetPrescoringFilters() {
    this.props.removeParam('monthly_rate');
    this.props.removeParam('deposit');
    this.resetCustomerTypeFilter();
  }

  render() {
    const { isLoading, isOpen } = this.props;
    let { inputData, logic } = this.props;
    inputData = inputData && inputData.hasOwnProperty('_root') ? inputData.toJS() : inputData || {};
    logic = logic && logic.hasOwnProperty('_root') ? logic.toJS() : logic || [];

    return (
      <Modal
        title=""
        className="prescoring-tool-modal"
        visible={isOpen}
        onCancel={this.handleCancel}
        footer={[
          <Button
            key="submit"
            type="primary"
            onClick={() => this.handleSubmit()}
            size="large"
            disabled={!this.canSubmit || (!this.state.inputHasChanged && this.state.inputIsChanging)}
          >
            Calcola sostenibilità
          </Button>,
          <Button
            key="reset"
            onClick={this.handleReset}
            size="large"
            className="pull-left"
            disabled={!this.canReset}
          >
            Reset
          </Button>,
          logic && this.logicSteps.length > 0 && <div
            key="progress"
            className="pull-left ml-5 mt-2"
            style={{width: '55%'}}
          >
            <Progress
              strokeWidth={5}
              strokeColor={{
                '0%': '#1B55E2',
                '100%': '#2ec58d',
              }}
              percent={(this.logicSteps.length / logic.length) * 100}
              format={() => `${this.logicSteps.length} / ${logic.length}`}
              status={this.logicSteps.length !== logic.length ? 'active' : 'normal'}
            />
          </div>
        ]}
      >
        <Form className="position-relative">
        <Loader loading={isLoading} />
          <Row>
            <Col>
              <Form.Item label="Categoria contrattuale" required>
                <Select
                  value={inputData.contractualCategory}
                  onChange={value => this.handleContractualCategoryChange(value)}
                >
                {
                  CONTRACTUAL_CATEGORIES.map(contractualCategoryItem => (
                    <Select.Option
                      key={contractualCategoryItem.value}
                      value={contractualCategoryItem.value}
                    >
                      {contractualCategoryItem.description}
                    </Select.Option>
                  ))
                }
                </Select>
              </Form.Item>
            </Col>
            {this.logicSteps.length > 0 && this.logicSteps.map(logicField => (
              <LogicField
                key={logicField.q}
                type={logicField.type}
                q={logicField.q}
                options={logicField.list || []}
                onChange={value => this.handleInputChange(logicField.q, value)}
                onChangeSubmit={value => this.handleSubmit(logicField.q, value)}
                value={typeof inputData.answers[logicField.q] !== 'undefined' ? inputData.answers[logicField.q] : (logicField.default || null)}
                hasSubmitButton={logicField.type === 'TYPE_INPUT' && (this.state.inputIsChanging === logicField.q)}
              />
              )
            )}
          </Row>
          {this.response && this.response.chance !== null &&
          <Row>
            <Col>
            <ResponseFeedback type={this.alertType} responseDescription={this.response.description} />
            </Col>
          </Row>
          }
        </Form>
      </Modal>
    );
  }
}

const ResponseFeedback = ({ type, responseDescription }) => {
  responseDescription = responseDescription === 'CONGRATULATIONS_THIS_OFFER' ? 'CONGRATULATIONS_OFFERS' : responseDescription;
  const text = MAPPED_FIELDS.a[responseDescription] || MAPPED_FIELDS.a['CONGRATULATIONS_OFFERS'];
  const TextComponent = () => <span>{text} <a href="/offers" aria-label={'Vetrina Offerte'}>Vai alla vetrina offerte</a></span>;

  return <Alert message={<TextComponent />} className={`alertWithMessage alert alert-${type}`} />;
}

const LogicField = ({type, q, options, onChange, onChangeSubmit, value, hasSubmitButton}) => {
  switch (type) {
    case 'TYPE_BOOL':
      return <LogicFieldBool q={q} onChange={onChange} onChangeSubmit={onChangeSubmit} value={value} />;
    case 'TYPE_INPUT':
      return <LogicFieldInput q={q} onChange={onChange} onChangeSubmit={onChangeSubmit} value={value} hasSubmitButton={hasSubmitButton} />;
    case 'TYPE_CHOICE':
      return <LogicFieldChoice q={q} options={options} onChangeSubmit={onChangeSubmit} onChange={onChange} value={value} />;
    default: return <></>;
  }
}

const LogicFieldBool = ({q, onChange, onChangeSubmit, value}) => <Form.Item label={MAPPED_FIELDS.q[q]} required>
  <Radio.Group
    buttonStyle="solid"
    name={q}
    onChange={({target: {value}}) => {onChange(value); onChangeSubmit(value);}}
    value={value}
  >
    <Radio.Button value={true}>
      Sì
    </Radio.Button>
    <Radio.Button value={false}>
      No
    </Radio.Button>
  </Radio.Group>
</Form.Item>

const LogicFieldInput = ({q, onChange, onChangeSubmit, value, hasSubmitButton}) => <Form.Item label={MAPPED_FIELDS.q[q]} required>
  <Input.Group compact>
    <InputNumber
      formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
      parser={value => value.replace(/\.*/g, '')}
      onChange={onChange}
      value={value}
      step={1}
      min={0}
      style={{width: '30%'}}
    />
    {hasSubmitButton &&
      <Button
        className="success"
        disabled={
          (value === '' || value === null || value === undefined)
        }
        onClick={() => onChangeSubmit(value)}
      >Ok</Button>
    }
  </Input.Group>
</Form.Item>

const LogicFieldChoice = ({q, options, onChange, onChangeSubmit, value}) => <Form.Item label={MAPPED_FIELDS.q[q]} required>
  <Select
    value={value}
    onChange={value => {onChange(value); onChangeSubmit(value);}}
  >
  {
    options.map(option => (
      <Select.Option
        key={option}
        value={option}
      >
        {MAPPED_FIELDS.list[option]}
      </Select.Option>
    ))
  }
  </Select>
</Form.Item>

PrescoringModal.defaultProps = {
  isLoading: false,
  isOpen: false,
};

PrescoringModal.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  inputData: PropTypes.any,
  isOpen: PropTypes.bool.isRequired,
  logic: PropTypes.any,
  response: PropTypes.any,
};

const withReducer = injectReducer({ key: 'prescoring', reducer });
const withSaga = injectSaga({ key: 'prescoring', saga });

const mapStateToProps = createStructuredSelector({
  isLoading: makeSelectIsLoading(),
  inputData: makeSelectCheckInputData(),
  isOpen: makeSelectModalIsOpen(),
  logic: makeSelectLogic(),
  response: makeSelectCheckResponse(),
});

export function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => dispatch(closeModal()),
    setInputData: inputData => dispatch(setInputData(inputData)),
    setContractualCategory: contractualCategory => dispatch(setContractualCategory(contractualCategory)),
    sendCheckSustainability: () => dispatch(sendCheckSustainability()),
    resetData: () => dispatch(resetData()),
    resetOfferData: () => dispatch(resetOfferData()),
    addOption: (value, label) => dispatch(addOption(value, label)),
    hideTag: value => dispatch(hideTag(value)),
    removeOption: (value) => dispatch(removeOption(value)),
    showTag: value => dispatch(showTag(value)),
    enableTags: value => dispatch(enableTags()),
    removeParam: name => dispatch(removeParam(name)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);
export default compose(
  withSaga,
  withReducer,
  withConnect,
)(PrescoringModal);
